import React from 'react';
import ButtonDD from "../components/ButtonDD";
import {AddEditItemProvider} from "../../PriceCatalogPage/contexts/AddEditItemContext";
import PopupAddEditItem from "../../PriceCatalogPage/components/PopupAddEditItem/PopupAddEditItem";
import {DeleteItemProvider} from "../../PriceCatalogPage/contexts/DeleteItemContext";
import PopupDeleteItem from "../../PriceCatalogPage/components/PopupDeleteItem/PopupDeleteItem";

export function PriceCatalogActionsColumnFormatter(cellContent) {
  const id = cellContent?.id ?? 0;
  return (
    <div className="d-flex justify-content-end align-items-center">
      <ButtonDD
        items={[{
          itemContent: (
            <div className="d-flex justify-content-between align-items-center">
              <AddEditItemProvider id={id}>
                <PopupAddEditItem/>
              </AddEditItemProvider>
              <DeleteItemProvider id={id}>
                <PopupDeleteItem/>
              </DeleteItemProvider>
            </div>
          )
        }
        ]}
      />
    </div>
  );
}
